import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { autoUpdate, flip, FloatingPortal, offset, shift, useClick, useDismiss, useFloating, useInteractions } from '@floating-ui/react';
import { IconChevronBottom } from '@travel-frontend/icons';
import { useState } from 'react';
import { CountryCode } from '../../../../components/CountrySwitch/components/CountrySwitchDesktop/components/CountryCode.js';
import { Label } from '../../../../components/CountrySwitch/components/CountrySwitchDesktop/components/Label/index.js';
import { SelectWrapper } from '../../../../components/CountrySwitch/components/CountrySwitchDesktop/SelectWrapper.js';
import { WidgetWrapper } from '../../../../components/CountrySwitch/components/WidgetWrapper.js';
import { Dropdown } from '../../../../components/internal/Dropdown/index.js';
import { Fade, Stack } from '../../../../primitives/index.js';
import { useDirectusImageUrl } from '../../../../utils/directus.js';
import { HEADER_QA_ID, qaId } from '../../../../utils/qaId.js';
import { SPACING_LARGE, SPACING_XSMALL } from '../../../../utils/spacingLegacy.js';
export const CountrySwitchDesktop = ({
  countrySwitchData
}) => {
  const [infoVisible, setInfoVisible] = useState(false);
  const {
    refs,
    context,
    floatingStyles
  } = useFloating({
    open: infoVisible,
    onOpenChange: setInfoVisible,
    middleware: [offset(29), flip(), shift()],
    placement: 'bottom',
    whileElementsMounted: autoUpdate
  });
  const {
    getReferenceProps,
    getFloatingProps
  } = useInteractions([useClick(context), useDismiss(context, {})]);
  const {
    items,
    active
  } = countrySwitchData;
  const image = useDirectusImageUrl(active?.icon?.url);
  return _jsxs(WidgetWrapper, {
    children: [_jsxs(Stack, {
      onClick: () => setInfoVisible(true),
      direction: "row",
      alignItems: "center",
      spacing: SPACING_XSMALL,
      ref: refs.setReference,
      ...getReferenceProps(),
      children: [active?.icon.url && _jsx("img", {
        width: 21,
        height: 15,
        src: image,
        alt: ""
      }), active?.countryCode && _jsx(CountryCode, {
        transform: "uppercase",
        children: active.countryCode
      }), _jsx(IconChevronBottom, {})]
    }), _jsx(FloatingPortal, {
      children: _jsx(Fade, {
        in: infoVisible,
        children: _jsx(Dropdown, {
          "data-cy": qaId(HEADER_QA_ID, 'hotline', 'floatingportal'),
          "data-testid": qaId(HEADER_QA_ID, 'hotline', 'floatingportal'),
          ref: refs.setFloating,
          style: floatingStyles,
          ...getFloatingProps(),
          children: _jsx(SelectWrapper, {
            spacing: SPACING_LARGE,
            children: items.map((item, index) => _jsx(Label, {
              data: item
            }, index))
          })
        })
      })
    })]
  });
};